// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import SearchTextField from "@tps/Overrides/Widgets/OrderHistory/SearchTextField";
import * as React from "react";

interface OwnProps extends WidgetProps {}

type Props = OwnProps;

const OrderHistorySearchFieldOrderedBy: React.FC<Props> = () => {
    return (
        <SearchTextField
            parameterField="orderedBy"
            label="Ordered By"
            inputType="text"
            placeholder=""
            testSelector="orderHistory_filterOrderedBy"
        />
    );
};

const widgetModule: WidgetModule = {
    component: OrderHistorySearchFieldOrderedBy,
    definition: {
        group: "Order History",
        displayName: "Ordered By",
        allowedContexts: ["OrderHistoryPage", "VmiOrderHistoryPage"],
    },
};

export default widgetModule;
